import {useTheme} from 'styled-components';
import {CustomIcon} from '@guestapp/ui';
import {FileBox, FileName} from '../styled';
import {downloadFromLink} from 'utils/common';

type Props = {
  name: string;
  url?: string;
};
function File({name, url = ''}: Props) {
  const theme = useTheme();
  return (
    <FileBox>
      <CustomIcon
        name="shareDownload"
        size={50}
        color={theme.colors.branding.fontPrimary}
      />
      <FileName>{name}</FileName>
      <div
        className="file-box__download-icon-container"
        onClick={() => downloadFromLink(url)}
      >
        <CustomIcon name="download" size={24} color={theme.colors.branding.icons} />
      </div>
    </FileBox>
  );
}

export {File};
